import {
    BottomNavigation,
    BottomNavigationAction,
    Paper
} from "@mui/material";
import ArchiveIcon from "@mui/icons-material/Archive";
import {
    Home as HomeIcon,
    ManageSearch as ManageSearchIcon,
} from "@mui/icons-material";
import {useNavigate} from "react-router";

export const BottomNavbar = () => {
    const navigate = useNavigate();

    return (
        <Paper sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10,
        }} elevation={3}>
            <BottomNavigation
                sx={{backgroundColor: '#e9e9e9'}}
                showLabels
                id="bottom-nav"
            >
                <BottomNavigationAction
                    label="Home"
                    icon={<HomeIcon />}
                    onClick={() => navigate('/')}
                />
                <BottomNavigationAction
                    label="Ricerca"
                    icon={<ManageSearchIcon />}
                    onClick={() => navigate('/search')}
                />
            </BottomNavigation>
        </Paper>
    )
}